import { useEffect, useMemo, useState } from "react";
import styles from "./borrowingCapacityApllicantInfo1.module.css";
import CurrencyInput from "react-currency-input-field";

const BorrowingCapacityApllicantInfo1 = ({
  numberOfApplicants,
  onNumberOfApplicantsChange,
  numberOfDependant,
  dependants,
  onNumberOfDependantChange,
  rate,
  onRateChange,
  year,
  years,
  onYearsChange,
  annualIncome1,            // controlled value from parent
  annualIncome2,            // controlled value from parent
  onAnnualIncome1,
  onAnnualIncome2,
  onValidityChange,         // optional: parent can subscribe to validity changes
}) => {
  const [a1Touched, setA1Touched] = useState(false);

  // robust numeric parse for $ strings / commas
  const a1ValueNum = useMemo(() => {
    const n = Number(String(annualIncome1 ?? "").replace(/[^\d.]/g, ""));
    return Number.isFinite(n) ? n : 0;
  }, [annualIncome1]);

  const a1HasError = a1Touched && a1ValueNum <= 0;
  const isValid = a1ValueNum > 0;

  // let parent know (so it can disable Next)
  useEffect(() => {
    if (typeof onValidityChange === "function") onValidityChange(isValid);
  }, [isValid, onValidityChange]);

  return (
    <>
      {/* 📌 Step 1 Heading + Divider */}
      <h2 className={styles.heading}>Step 1 of 2 </h2>
      <hr className={styles.divider} />

      <div className={`col-m-6 ${styles.applicants_wrapper}`}>
        <button
          className={`${styles.btn} ${
            numberOfApplicants === 1 ? styles.btn_selected : styles.btn_unselected
          }`}
          name="numberOfApplicants"
          id="singleApplication"
          onClick={() => onNumberOfApplicantsChange(1)}
        >
          Single applicant
        </button>
        <button
          className={`${styles.btn} ${
            numberOfApplicants === 2 ? styles.btn_selected : styles.btn_unselected
          }`}
          name="numberOfApplicants"
          id="jointApplication"
          onClick={() => onNumberOfApplicantsChange(2)}
        >
          Joint application
        </button>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>
          Number of dependants (under the age of 18)
        </label>
        <select
          id="bcDependants"
          onChange={(e) => onNumberOfDependantChange(e.target.value)}
          className="form-select"
          defaultValue={numberOfDependant}
        >
          {dependants.sort((a, b) => a - b).map((value) => (
            <option key={value} value={value}>{value}</option>
          ))}
        </select>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>
          Based on our lowest rate / Input your own rate
        </label>
        <div className={styles.flex_wrapper}>
          <input
            id="bcRate"
            type="number"
            step={0.01}
            min={0}
            onChange={(e) => onRateChange(e.target.value)}
            className={`form-control ${styles.rate_holder}`}
            defaultValue={rate}
          />
          <span className={styles.labeld1}>%</span>
        </div>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Loan Term</label>
        <select
          id="bcYears"
          onChange={(e) => onYearsChange(e.target.value)}
          className="form-select"
          defaultValue={year}
        >
          {years.sort((a, b) => b - a).map((value) => (
            <option key={value} value={value}>{value} years</option>
          ))}
        </select>
      </div>

      {/* ===== Applicant 1 (Required) ===== */}
      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Applicant 1 income</label>
        <div className={styles.flex_wrapper}>
          <span className={styles.labeld}>$</span>
          <CurrencyInput
            className={`form-control ${styles.money_input} ${a1HasError ? styles.inputError : ""}`}
            id="bcIncome1"
            value={annualIncome1 ?? ""}                   // controlled
            decimalsLimit={2}
            onValueChange={(value) => onAnnualIncome1(value)}
            onBlur={() => setA1Touched(true)}
            aria-invalid={a1HasError || undefined}
            aria-describedby="a1-income-error"
            placeholder="0"
          />
        </div>
        {a1HasError && (
          <div id="a1-income-error" className={styles.errorMsg}>
            Applicant 1 income is required and must be greater than $0.
          </div>
        )}
      </div>

      {/* ===== Applicant 2 (optional) ===== */}
      {numberOfApplicants === 2 && (
        <div className="col-m-6">
          <label className={`form-label ${styles.label}`}>Applicant 2 income (optional)</label>
          <div className={styles.flex_wrapper}>
            <span className={styles.labeld2}>$</span>
            <CurrencyInput
              className={`form-control ${styles.money_input}`}
              id="bcIncome2"
              value={annualIncome2 ?? ""}                 // controlled
              decimalsLimit={2}
              onValueChange={(value) => onAnnualIncome2(value)}
              placeholder="0"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BorrowingCapacityApllicantInfo1;
